// extracted by css-extract-rspack-plugin
export default {"collapse":"VrN1PLbC0Uu3DtUV","content":"mEFb2Gp2YMQ6HmDp"};